import { useState } from 'react';
import { categories } from '@/mocks/seoData';

export default function CategorySection() {
  const [activeCategory, setActiveCategory] = useState(categories[0]);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Browse <strong>Sugargoo Spreadsheet</strong> Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Select a product category to explore our organized <strong>Sugargoo Spreadsheet</strong> collections.
            Each category links directly to detailed product listings with vetted finds and QC photos.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-80 shrink-0">
            <label htmlFor="category-select" className="block text-sm font-semibold text-foreground-700 mb-2">
              Choose a Category
            </label>
            <div className="relative">
              <select
                id="category-select"
                value={activeCategory.name}
                onChange={(e) => {
                  const found = categories.find((c) => c.name === e.target.value);
                  if (found) setActiveCategory(found);
                }}
                className="w-full appearance-none bg-background-50 border border-background-200/70 rounded-lg px-4 py-3 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-300 pr-10"
              >
                {categories.map((cat) => (
                  <option key={cat.seq} value={cat.name}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <i className="ri-arrow-down-s-line absolute right-3 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none"></i>
            </div>

            <div className="mt-4 rounded-lg overflow-hidden border border-background-200/70 aspect-[4/3] bg-background-200">
              <img
                src={activeCategory.imageUrl}
                alt={activeCategory.name}
                className="w-full h-full object-cover"
              />
            </div>

            <a
              href={activeCategory.url}
              target="_blank"
              rel="noopener nofollow"
              className="mt-4 block w-full px-5 py-3 text-sm font-semibold bg-primary-500 text-white rounded-md hover:bg-primary-600 transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
            >
              Go to {activeCategory.name}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3" data-product-shop>
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className={`flex flex-col rounded-lg border transition-all duration-200 cursor-pointer group overflow-hidden ${
                  activeCategory.name === cat.name
                    ? 'border-primary-300 ring-1 ring-primary-200'
                    : 'border-background-200/70 hover:border-primary-200'
                }`}
              >
                <div className="aspect-[4/3] overflow-hidden bg-background-200">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className={`flex items-center gap-2 px-3 py-2.5 ${
                  activeCategory.name === cat.name
                    ? 'bg-primary-50'
                    : 'bg-background-50 group-hover:bg-primary-50/50'
                }`}>
                  <div className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 ${
                    activeCategory.name === cat.name
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-background-100 text-foreground-500 group-hover:bg-primary-100 group-hover:text-primary-600'
                  }`}>
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-700 group-hover:text-foreground-900 whitespace-nowrap">{cat.name}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}